import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function BatchSftpProcessMakeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    id: Yup.number(),
    processName: Yup.string(),
    processNode: Yup.string(),
    nextTriggerDate: Yup.date().validFormat("YYYY-MM-DD HH:mm:ss").typeError(dateTypeErrorMessage),
    startProcessDate: Yup.date().validFormat("YYYY-MM-DD HH:mm:ss").typeError(dateTypeErrorMessage),
    endProcessDate: Yup.date().validFormat("YYYY-MM-DD HH:mm:ss").typeError(dateTypeErrorMessage),
  })
}

export default BatchSftpProcessMakeValidationSchema
